// These constants are injected via webpack environment variables.
// You can add more variables in webpack.common.js or in profile specific webpack.<dev|prod>.js files.
// If you change the values in the webpack config files, you need to re run webpack to update the application

export const VERSION = process.env.VERSION;
// export const DEBUG_INFO_ENABLED: boolean = !!process.env.DEBUG_INFO_ENABLED;
export const SERVER_API_URL = process.env.SERVER_API_URL;
export const BUILD_TIMESTAMP = process.env.BUILD_TIMESTAMP;

// Errors
export const PROBLEM_BASE_URL = 'https://www.jhipster.tech/problem';
export const EMAIL_ALREADY_USED_TYPE = PROBLEM_BASE_URL + '/email-already-used';
export const LOGIN_ALREADY_USED_TYPE = PROBLEM_BASE_URL + '/login-already-used';

export const ERR_FORM_INVALID =
  'Certaines informations sont manquantes ou incorrectes, merci de renseigner / corriger les champs concernés et de soumettre à nouveau votre demande.';
export const ERR_INSCRIPTION_FAILED =
  "Une erreur est survenue lors de l'enregistrement de votre inscription. Merci de réessayer ou de nous contacter si le problème persiste.";

// API
export const BASE_API_URL = 'api/';
export const PREFIX_API_PUBLIC = 'public/';

// Form validation constraints
export const MIN_AGE = 16;
export const MIN_BIRTH_DATE = new Date(1900, 0, 1);
export const PHOTO_IDENTITY_MIME_TYPES = ['image/gif', 'image/jpeg', 'image/png'];
export const CARD_IDENTITY_MIME_TYPES = ['image/gif', 'image/jpeg', 'image/png', 'application/pdf'];

// Media types
export const MEDIA_TYPE_TEXT = 'text/plain';
export const MEDIA_TYPE_PDF = 'application/pdf';
